import { render, staticRenderFns } from "./AppSettingModal.vue?vue&type=template&id=60ff8e14"
import script from "./AppSettingModal.vue?vue&type=script&lang=js"
export * from "./AppSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports